import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getApiBaseUrl } from "../../config";

const baseQuery = fetchBaseQuery({
  baseUrl: getApiBaseUrl(),
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const user = getState().user?.currentUser;
    if (user?.id) {
      headers.set("userid", user.id);
    }
    return headers;
  },
});

export const mvdTableApi = createApi({
  reducerPath: "mvdTableApi",
  baseQuery,
  tagTypes: ["MvdTable"],
  endpoints: (builder) => ({
    // Get all MVD tables
    getMvdTable: builder.query({
      async queryFn(arg = undefined, queryApi, extraOptions, baseQuery) {
        try {
          const params = arg || {};
          const result = await baseQuery({
            url: "mvds-table",
            params,
          });
          return result;
        } catch (error) {
          console.error("Error fetching MVD table:", error);
          return { data: { data: [] } };
        }
      },
      providesTags: ["MvdTable"],
    }),
  }),
});

export const { useGetMvdTableQuery } = mvdTableApi;
